module.exports = __webpack_public_path__ + "static/media/objects2_15.06166c1d.svg";